import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const File = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <path
            fillRule="evenodd"
            d="M7 8a4 4 0 0 1 4-4h21.828L41 12.172V40a4 4 0 0 1-4 4H11a4 4 0 0 1-4-4V8Zm24.172 0H11v32h26V13.828L31.172 8Zm-1.175 15H18.003A2.015 2.015 0 0 1 16 20.985C16 19.91 16.899 19 18.003 19h11.994c1.105 0 2.003.91 2.003 2.015C32 22.09 31.102 23 29.997 23m-5.97 8h-6.053C16.869 31 16 30.09 16 28.985 16 27.91 16.87 27 17.974 27h6.052c1.105 0 1.974.91 1.974 2.015C26 30.09 25.13 31 24.026 31"
            style={{ mixBlendMode: 'passthrough' }}
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
